import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Center, Skeleton, Stack } from '@mantine/core';
import { nprogress } from '@mantine/nprogress';

import { AppShellLayout } from '@/components/layout/AppShell';
import { PostHogPageView } from '@/components/analytics/PostHogPageView';
import { useApprovalBadgeCount } from '@/hooks/useApprovals';
import { useAuth } from '@/hooks/useAuth';
import { canApprove } from '@/auth/roleAccess';

function PageLoader() {
  useEffect(() => {
    nprogress.start();
    return () => nprogress.complete();
  }, []);

  return (
    <Center h="50vh" role="status" aria-label="Loading page">
      <Stack w="min(100%, 720px)" gap="md">
        <Skeleton height={28} width="38%" radius="sm" />
        <Skeleton height={120} radius="md" />
        <Skeleton height={180} radius="md" />
      </Stack>
    </Center>
  );
}

export default function RootLayout() {
  const { user } = useAuth();
  const hasApprovalAccess = canApprove(user?.role);
  const { data: badge } = useApprovalBadgeCount(hasApprovalAccess);
  const pendingApprovals = hasApprovalAccess ? (badge?.count ?? 0) : 0;
  const approvalsBadge = pendingApprovals > 0 ? pendingApprovals : undefined;

  return (
    <>
      <PostHogPageView />
      <AppShellLayout
        navBadges={{ approvals: approvalsBadge }}
        mobileBadges={{ approvals: approvalsBadge }}
      >
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </AppShellLayout>
    </>
  );
}
